import React, { ReactNode } from 'react'
import { FacilityItem } from './FacilityItem'
import { PostCallout } from '../PostCallout'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { PostFacilityCard } from '../../../../generated/api/post-row'

interface PostFacilitiesProps {
  facilities: PostFacilityCard[]
}

export const PostFacilities = ({
  facilities,
}: PostFacilitiesProps): ReactNode => {
  const { translate } = useAppTranslation()

  if (facilities.length === 0) {
    return null
  }

  return (
    <div className="flex w-full flex-col gap-4">
      <PostCallout text={translate('post.newFacilityText')} />
      {facilities.map((facility) => (
        <FacilityItem key={facility.id} facility={facility} />
      ))}
    </div>
  )
}
